<template>
  <div
    class="input-group lar_input_group"
  >
    <div
      v-if="hasPrepend"
      class="input-group-prepend"
    >
      <slot name="prepend" />
      <span
        v-if="prepend"
        class="input-group-text"
      >
        {{ prepend }}
      </span>
    </div>
    <slot />
    <div
      v-if="hasError"
      class="invalid-tooltip"
    >
      {{ errorMessage | joinErrorMessages }}
    </div>
    <div
      v-if="hasAppend"
      class="input-group-append"
    >
      <slot name="append" />
      <span
        v-if="append"
        class="input-group-text"
      >
        {{ append }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InputGroup',
  filters: {
    joinErrorMessages (value) {
      if (typeof value !== 'object') {
        return value
      }
      return Object.keys(value).filter(key => value[key]).join(', ')
    }
  },
  props: {
    prepend: {
      type: String,
      default: ''
    },
    append: {
      type: String,
      default: ''
    },
    hasError: Boolean,
    errorMessage: {
      type: [String, Object],
      default: ''
    }
  },
  computed: {
    hasPrepend () {
      return !!this.prepend || Object.keys(this.$slots).includes('prepend')
    },
    hasAppend () {
      return !!this.append || Object.keys(this.$slots).includes('append')
    }
  }
}
</script>
<style lang="scss" scoped>
.lar_input_group {
  .input-group-text {
    background: #fff;
  }
  .input-group-prepend {
    .input-group-text {
      border-right: 0;
    }
    .form-control {
       border-left: 0;
    }
  }
  .input-group-append {
    .input-group-text {
      border-left: 0;
    }
  }
  .form-control {

    // padding: 0.375rem 1.12rem;
    &:not(first-child) {
      .form-control {
        border-left: 0;
      }
    }

    &:not(textarea) {
    //   height: calc(1.6em + .75rem + 4px);
    height: 39.25px;
    }
  }
}
</style>
